import React, { useState } from 'react';
import styled from 'styled-components';
import { FaCode } from 'react-icons/fa';
import { projectName } from '../../utils/projectHelpers';

const Visual = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 24px;
  color: var(--accent);
  background: var(--surface-soft);
  border-bottom: 1px solid var(--border);
  svg { width: 32px; height: 32px; }
  span { color: var(--muted); font-size: 12px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; }
`;
const Preview = styled.img`
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9;
  object-fit: contain;
  background: var(--surface-soft);
`;

export default function ProjectMedia({ project, large = false }) {
  const [failed, setFailed] = useState(false);
  if (project.imageVerified && project.image && !failed) {
    return <Preview src={project.image} alt={`${projectName(project)} application screenshot`} width={1520} height={855} loading="lazy" decoding="async" onError={() => setFailed(true)} />;
  }
  return <Visual $large={large} aria-hidden="true"><FaCode /><span>{project.category || 'Engineering Project'}</span></Visual>;
}
